import React from "react";
import PropTypes from "prop-types";
import { Grid, FormHelperText } from "@mui/material";
import { Button } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import ContactDataRowComponent from "./ContactDataRowComponent";
import { isValid } from "@totalsoft/pure-validations-react";
import CardNoResultsWrapper from "components/layout/CardNoResultsWrapper";

export const ContactDataListComponent = ({
  contactInfoList,
  positions,
  saveContactInfos,
  addContactInfo,
  deleteContactInfo,
  onPropertyChange,
  loadPersons,
  partnerId,
  saveDisabled,
  validation,
  validDefaultContactInfo,
  validESignatureContactInfo,
  loadPartnerDetails,
  hasWritePermission
}) => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <CardNoResultsWrapper content={contactInfoList}>
          {contactInfoList?.map((document, idx) => {
            return (
              <ContactDataRowComponent
                key={idx}
                idx={idx}
                contactInfo={document}
                positions={positions}
                deleteContactInfo={() => deleteContactInfo(document)}
                validation={validation[idx]}
                onPropertyChange={onPropertyChange(idx)}
                loadPersons={loadPersons}
                loadPartnerDetails={loadPartnerDetails}
                hasWritePermission={hasWritePermission}
              />
            );
          })}
        </CardNoResultsWrapper>
        {!validDefaultContactInfo && (
          <FormHelperText error={true} id="name-error-text">
            {t("ContactInfo.ValidateUniqueDefaultContactInfo")}
          </FormHelperText>
        )}
        {!validESignatureContactInfo && (
          <FormHelperText error={true} id="name-error-text">
            {t("ContactInfo.ValidateUniqueESignatureContactInfo")}
          </FormHelperText>
        )}
        <Button
          id="contactData_addBtn"
          color="primary"
          variant="contained"
          onClick={() => addContactInfo()}
          disabled={!hasWritePermission}
          sx={{ marginTop: "1.5rem" }}
        >
          {t("Add")}
        </Button>
        <Button
          id="contactData_saveBtn"
          color="primary"
          variant="contained"
          onClick={() => saveContactInfos(partnerId, contactInfoList)}
          disabled={!hasWritePermission || saveDisabled || !isValid(validation)}
          sx={{ marginLeft: ".25rem", marginTop: "1.5rem" }}
        >
          {t("Save")}
        </Button>
      </Grid>
    </Grid>
  );
};

ContactDataListComponent.propTypes = {
  contactInfoList: PropTypes.array,
  positions: PropTypes.array.isRequired,
  addContactInfo: PropTypes.func.isRequired,
  saveContactInfos: PropTypes.func.isRequired,
  deleteContactInfo: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  loadPersons: PropTypes.func.isRequired,
  partnerId: PropTypes.number,
  validation: PropTypes.object.isRequired,
  saveDisabled: PropTypes.bool,
  validDefaultContactInfo: PropTypes.bool,
  validESignatureContactInfo: PropTypes.bool,
  loadPartnerDetails: PropTypes.func,
  hasWritePermission: PropTypes.bool.isRequired
};
export default ContactDataListComponent;
